<div class="page-container" [ngStyle]="{ 'height': pageContainerHeight }">
    <div class="mt-1">
        <cl-logs-viewer [componentId]="componentId"></cl-logs-viewer>
    </div>
</div>